import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  CHECKBOX_CHECKED,
  CHECKBOX_SHAPE,
  Checkbox,
  DSBottomSheet,
  DSButton,
  DSModal,
  DSRadio,
} from '@repo/design-system/index'
import { QIcon_refresh } from '@repo/icons/index'
import { useState } from 'react'
import { n_book_lessons, n_common, n_point } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

export const FilterPopup = ({ isOpen, setIsOpen, handleApply }) => {
  const { t } = useTranslation()
  const [gender, setGender] = useState(null)
  const [accent, setAccent] = useState(null)
  const [major, setMajor] = useState(null)
  const [etcList, setEtcList] = useState([])
  const onSubmit = (e) => {
    const payload = {
      gender: gender,
      major: major,
      accent: accent,
      is_prev_tutor: etcList.length > 0,
    }
    handleApply(e, payload)
    setIsOpen(false)
  }
  const handleReset = () => {
    setGender(null)
    setMajor(null)
    setAccent(null)
    setEtcList([])
  }

  return (
    <DSModal id="ContentsSMTwoButtonHorizontalPopup" isOpen={isOpen} setIsOpen={setIsOpen} size="xl">
      <DSModal.Title>{t(n_book_lessons.filter.title)}</DSModal.Title>
      <DSModal.Content className="max-h-[472px] overflow-y-scroll">
        <FilterBody
          genderList={gender}
          setGenderList={setGender}
          accentList={accent}
          setAccentList={setAccent}
          majorList={major}
          setMajorList={setMajor}
          etcList={etcList}
          setEtcList={setEtcList}
        />
      </DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal" classNameFromProps="w-full">
        <div className="flex w-full justify-between">
          <div className="flex cursor-pointer items-center" onClick={handleReset}>
            <QIcon_refresh width={20} height={20} color={COLORS.GRAY500} />
            <div className="Body2-14Bd ml-[8px] text-gray-600">{t(n_common.btn_refresh)}</div>
          </div>
          <div className="flex items-center justify-end gap-x-[8px] whitespace-nowrap">
            <DSButton
              size={BUTTON_SIZE.MD}
              type={BUTTON_TYPE.OUTLINE}
              customBgColor={COLORS.WHITE}
              onClick={() => setIsOpen(false)}
            >
              <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
            </DSButton>
            <DSButton size={BUTTON_SIZE.MD} onClick={onSubmit}>
              <DSButton.Label>{t(n_common.btn_filter)}</DSButton.Label>
            </DSButton>
          </div>
        </div>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export const FilterBottomSheet = ({ isOpen, setIsOpen, handleApply }) => {
  const { t } = useTranslation()
  const [gender, setGender] = useState(null)
  const [accent, setAccent] = useState(null)
  const [major, setMajor] = useState(null)
  const [etcList, setEtcList] = useState([])
  const onSubmit = (e) => {
    const payload = {
      gender: gender,
      major: major,
      accent: accent,
      is_prev_tutor: etcList.length > 0,
    }
    handleApply(e, payload)
    setIsOpen(false)
  }
  const handleReset = () => {
    setGender(null)
    setMajor(null)
    setAccent(null)
    setEtcList([])
  }
  return (
    <DSBottomSheet
      closeButton={true}
      onClose={() => setIsOpen(false)}
      id="FilterBottomSheet"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeOnDim={true}
    >
      <FilterBody
        genderList={gender}
        setGenderList={setGender}
        accentList={accent}
        setAccentList={setAccent}
        majorList={major}
        setMajorList={setMajor}
        etcList={etcList}
        setEtcList={setEtcList}
      />
      <div className="mt-[6px] flex items-center justify-between px-[16px] pt-[12px] pb-[34px]">
        <div className="flex items-center" onClick={handleReset}>
          <QIcon_refresh width={20} height={20} />
          <div className="Body2-14Bd ml-[8px] text-gray-500">{t(n_common.btn_refresh)}</div>
        </div>
        <div>
          <DSButton size={BUTTON_SIZE.LG} onClick={onSubmit}>
            <DSButton.Label>{t(n_common.btn_filter)}</DSButton.Label>
          </DSButton>
        </div>
      </div>
    </DSBottomSheet>
  )
}

const FilterBody = ({
  genderList,
  setGenderList,
  accentList,
  setAccentList,
  majorList,
  setMajorList,
  etcList,
  setEtcList,
}) => {
  const { t } = useTranslation()

  const genderOptions = [
    { label: t(n_point.filter_all), value: null },
    { label: t(n_book_lessons.filter.gender_male), value: 1 },
    { label: t(n_book_lessons.filter.gender_female), value: 0 },
  ]
  const accentOptions = [
    { label: t(n_point.filter_all), value: null },
    { label: t(n_book_lessons.filter.accent_usa), value: 0 },
    { label: t(n_book_lessons.filter.accent_british), value: 2 },
  ]

  const majorOptions = [
    { label: t(n_point.filter_all), value: null },
    { label: t(n_book_lessons.filter.major_social_science), value: 0 },
    { label: t(n_book_lessons.filter.major_liberal_arts), value: 1 },
    { label: t(n_book_lessons.filter.major_engineering), value: 2 },
    { label: t(n_book_lessons.filter.major_natural_science), value: 3 },
    { label: t(n_book_lessons.filter.major_fine_arts), value: 4 },
  ]
  return (
    <div className="relative px-[16px] pt-[4px] pb-[8px]">
      <div className="mt-[24px]">
        <div className="Body1-16Bd text-black">{t(n_book_lessons.filter.gender_title)}</div>
        <DSRadio
          controlSelected={[genderList, setGenderList]}
          containerClassName="mt-[8px] flex flex-col sm:grid sm:grid-cols-1 gap-[8px] text-[14px]"
        >
          {genderOptions.map((option, i) => {
            return (
              <DSRadio.Item key={i} value={option.value}>
                <span className="text-[14px]">{option.label}</span>
              </DSRadio.Item>
            )
          })}
        </DSRadio>
      </div>
      <div className="mt-[24px]">
        <div className="Body1-16Bd text-black">{t(n_book_lessons.filter.accent_title)}</div>
        <DSRadio
          controlSelected={[accentList, setAccentList]}
          containerClassName="mt-[8px] flex flex-col sm:grid sm:grid-cols-1 gap-[8px] text-[14px]"
        >
          {accentOptions.map((option, i) => {
            return (
              <DSRadio.Item key={i} value={option.value}>
                <span className="text-[14px]">{option.label}</span>
              </DSRadio.Item>
            )
          })}
        </DSRadio>
      </div>
      <div className="mt-[24px]">
        <div className="Body1-16Bd text-black">{t(n_book_lessons.filter.major_title)}</div>
        <DSRadio
          controlSelected={[majorList, setMajorList]}
          containerClassName="mt-[8px] flex flex-col sm:grid sm:grid-cols-1 gap-[8px] text-[14px]"
        >
          {majorOptions.map((option, i) => {
            return (
              <DSRadio.Item key={i} value={option.value}>
                <span className="text-[14px]">{option.label}</span>
              </DSRadio.Item>
            )
          })}
        </DSRadio>
      </div>
      <div className="mt-[24px]">
        <div className="Body1-16Bd text-black">{t(n_book_lessons.filter.etc_title)}</div>
        <Checkbox
          shape={CHECKBOX_SHAPE.SQUARE}
          type={CHECKBOX_CHECKED.CHECKED}
          controlSelected={[etcList, setEtcList]}
          containerClassName="flex flex-col gap-y-[8px] mt-[4px] text-[14px]"
        >
          <Checkbox.Item value={1}>
            <span className="text-[14px]">{t(n_book_lessons.filter.etc_tutors_met)}</span>
          </Checkbox.Item>
        </Checkbox>
      </div>
    </div>
  )
}
